import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { BreadcrumbsModule } from '../../breadcrumbs/breadcrumbs.module';
import { ContentComponent } from './content.component';
export class ContentModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, RouterModule, BreadcrumbsModule],
    exports: [ContentComponent],
    declarations: [ContentComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ContentModule_tsickle_Closure_declarations() {
/** @type {?} */
ContentModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ContentModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
